<template>
  <div v-if="room && room.profile" class="info-wrapper-box">
    <a href="#" @click.prevent="onClick">
      <div
        v-if="room.avatar"
        class="room-avatar"
        :style="{ 'background-image': `url('${room.avatar}?p=tiny')` }"
      >
        <div class="avatar-single__online-status"></div>
      </div>
    </a>
    <div>
      <a href="#" @click.prevent="onClick">
        <div class="room-name">{{ room.roomName }}</div>
        <div class="room-info">{{ trans.get('pages:chat.is_online_now') }}</div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RoomInfoAdmin',
  components: {},
  props: {
    room: {},
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    onClick() {

    },
  },
  watch: {},
  mounted() {
  }
};
</script>
